<script setup>
import {ref} from "vue";
import {getLogo} from "@/helpers/logo";

defineProps (['startups']);
const showModal = ref(false);

function open() {

    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" hide-footer modal-class="modal-w-lg">
        <div class="main-table-wrapper--light">
            <table class="main-table">
                <tbody>
                <tr v-for="(startup, index) in startups" :key="index">
                    <td>
                        <div class="main-table__data">
                            <div class="image-block">
                                <img v-if="'logoUrl' in startup" :src="getLogo(startup.logoUrl)" alt="">
                            </div>

                            <div class="pr-3">
                                <h5 class="heading5 d-flex align-items-center">
                                    <a
                                        v-if="'id' in startup"
                                        rel="noopener"
                                        target="_blank"
                                        :href="`/startups/${startup.id}`"
                                    >
                                        {{ startup.name }}
                                    </a>

                                    <span v-else>{{ startup.name }}</span>

                                    <span class="ml-2">
                                        ({{startup.source.join(', ')}})
                                    </span>
                                </h5>

                                {{ startup.website }}

                                <div>
                                    <span class="line-clamp">{{startup.shortDescription}}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<style scoped>

</style>
